export class SheetSelectUl {
    constructor(optionalOptions = {}) {
        this._selectOne = document.querySelectorAll('.sheet-column .sheet-select-ul li')
        if (!this._selectOne) {
            this.destructor();
            return true;
        }

        let value
        let target
        let text
        let input

        const removeSelectedMarker = (thatList) => {
            thatList.querySelector('li.selected').classList.remove('selected');
        }

        this._selectOne.forEach((one) => {
            one.addEventListener("click", () => {
                value = one.dataset.value
                target = one.dataset.target
                text = one.dataset.text
                input = one.dataset.input

                if (one.classList.contains('selected')) {
                    return false
                }

                removeSelectedMarker(one.closest('.sheet-select-ul'))

                one.classList.add('selected')

                if (value && input) {
                    if (document.querySelector(input)) {
                        document.querySelector(input).value = value
                    }
                }

                if (text && target) {
                    if (document.querySelector(target)) {
                        document.querySelector(target).innerHTML = text
                    }
                }
            })
        })
    }

    destructor() {
        this._selectOne = null;
    }
}

export default new SheetSelectUl();
